<template>
  <div class="login" ref="login">
    <a-dropdown>
      <a class="language-box" @click="e => e.preventDefault()">
        <icon-font type="gb-icon-Language" />
        {{ languageCodes[currentLang].label }} <a-icon type="down" />
      </a>
      <a-menu slot="overlay"  @click="changeLang" :selectedKeys="[currentLang]">
        <a-menu-item v-for="locale in Object.keys(languageCodes)" :key="locale">
          <span role="img" :aria-label="languageCodes[locale].label" style="margin-right: 4px">
            {{ languageCodes[locale].flag }}
          </span>
          {{ languageCodes[locale].label }}
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <div class="login-swiper">
      <div
        v-for="(item, index) in swiperList"
        :key="index"
        class="login-swiper-item"
        :style="{ background: `url(${ (item['bannerUrl' + codes[currentLang]] || item['bannerUrl'] || '').replace('eccang-ess.oss-cn-shenzhen.aliyuncs.com', 'file.eccang.com') }) no-repeat ${currentLang === 'zh_CN' ? 'center' : 'left'} top /cover` }"
        :class="{cur: index === swiperCurrent, cursor: item.jumpUrl ? true : false }"
        @click="bannerTo(item)"
      />
      <div class="login-swiper-pagination" v-if="swiperList.length > 1">
        <div v-for="(bool, index) in swiperList" :key="index" class="login-swiper-pagination__bool" :class="{cur: index === swiperCurrent}" @click="swiperTo(index)"></div>
      </div>
    </div>
    <div class="login-main">
      <section>
        <div class="login-main-logo">
          <icon-font type="gb-icon-yicangxinlogo" style="font-size: 180px" />
          <!-- <icon-font type="gb-icon-yicangxinlogo" v-else /> -->
        </div>
        <!-- title -->
        <div class="login-main-title" v-if="/^back/.test(comp)" >
          <a-button
            type="link"
            v-for="tab in backTabs"
            :key="tab.value"
            :style="{color: comp === tab.value ? '#1C2D42' : '#7F93A8'}"
            @click="comp = tab.value"
          >{{ tab.label }}</a-button>
        </div>
        <div class="login-main-title" v-else :style="titleFormat.length === 2 ? { 'letter-spacing': '8px' } : {}">
          {{ titleFormat }}
        </div>
        <!-- auth -->
        <auth-form v-if="$route.path === '/oauth/login'" @agreement="(type) => this[type] = true"></auth-form>
        <!-- content -->
        <login-form
          v-else-if="comp === 'login'"
          @to="to" @agreement="(type) => this[type] = true"
          @done="routeToMode"
        />
        <register-form
          v-else-if="comp === 'register'"
          @to="to"
          @agreement="(type) => this[type] = true"
          @done="routeToMode"
        />
        <bind-form
          v-else-if="comp === 'bind'"
          @to="to"
          @agreement="(type) => this[type] = true"
          @done="routeToMode"
        />
        <back-password-form
          v-else-if="/^back/.test(comp)"
          :comp="comp"
          @to="to"
          @agreement="(type) => this[type] = true"
          @done="routeToMode"
        />
      </section>
    </div>
    <agreement-modal :visible="agreementVisible" @ok="agreementVisible = false" />
    <policy-modal :visible="policyVisible" @ok="policyVisible = false" />
    <div class="weChat-wrapper" :class="[isWxQrCode && 'show']">
      <div class="ball1"></div>
      <div class="ball2"></div>
      <qr-code @to="to" :show.sync="isWxQrCode" @done="routeToMode" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginForm from './modules/LoginForm.vue'
import RegisterForm from './modules/RegisterForm.vue'
import BindForm from './modules/BindForm.vue'
import BackPasswordForm from './modules/BackPasswordForm.vue'
import AuthForm from './modules/AuthForm.vue'
// 协议
import AgreementModal from '@/components/Modal/AgreementModal'
import PolicyModal from '@/components/Modal/PolicyModal'
import QrCode from '@/components/QrCode'
import { querySystemServicePackageInfo } from '@/api/sso/subjectService'
import { ACCESS_TOKEN, LANGUAGE } from '@/store/mutation-types'
import i18nMixin from '@/store/i18n-mixin'

// import { bannerList } from '@/api/index'
import { bannerList } from '@/api/index'
// import { axios } from '@/api/sellerwell/request'
// import { getServiceCurrentDomainDetail } from '@/api/sso/role'

export default {
  components: {
    LoginForm,
    RegisterForm,
    BindForm,
    BackPasswordForm,
    AuthForm,
    AgreementModal,
    PolicyModal,
    QrCode
  },
  mixins: [i18nMixin],
  data () {
    return {
      swiperList: [],
      swiperCurrent: 0,
      timer: null,
      comp: 'login',
      unionId: undefined,
      openId: undefined,
      agreementVisible: false,
      policyVisible: false,
      isWxQrCode: false,
      codes: {
        'zh_CN': '',
        'en_US': 'En',
        'ko_KR': 'Kr'
      },
      languageCodes: {
        'zh_CN': {
          label: '简体中文',
          flag: '🇨🇳'
        },
        'en_US': {
          label: 'English',
          flag: '🇺🇸'
        },
        'ko_KR': {
          label: '한국어',
          flag: '🇰🇷'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'systems'
    ]),
    backTabs () {
      return [
        {
          label: this.$t('common_login_邮箱找回'),
          value: 'backEmail'
        },
        {
          label: this.$t('common_login_手机号找回'),
          value: 'backPhone'
        }
      ]
    },
    titleFormat () {
      const type = {
        login: this.$t('common_login_title'),
        register: this.$t('common_login_register'),
        bind: this.$t('common_login_首次登录绑定')
      }
      return type[this.comp]
    }
  },
  watch: {
    '$route.query': {
      handler (query) {
        const { register, source, linkId, firstLogin, unionId, openId, backEmail, inviteCode } = query
        let comp = 'login'

        if (
          (source && !['eccang', 'entry'].includes(source)) ||
          inviteCode ||
          register ||
          linkId
        ) {
          comp = 'register'
        }

        if (backEmail) {
          comp = backEmail
        }

        if (firstLogin) {
          comp = 'bind'
        }

        this.unionId = unionId
        this.openId = openId
        this.comp = comp
      },
      immediate: true
    }
  },
  created () {
    bannerList({ platformCode: 'SSO_SYS_USER_SAIL', paging: false, bannerStatus: 1 }).then(({ dataList }) => {
      this.swiperList = dataList
      if (dataList.length > 1) {
        this.swiperLoop()
      }
    })
  },
  methods: {
    bannerTo (item) {
      if (!item['jumpUrl']) return
      // window.open('https://' + item['jumpUrl'])
      window.open(item['jumpUrl'])
    },
    changeLang ({ key, chooseLanguage } = {}) {
      this.setLang(key || chooseLanguage || 'zh_CN')
      clearTimeout(this.timer)
      this.swiperCurrent = 0
    },
    swiperTo (index) {
      this.swiperCurrent = index
      this.swiperLoop()
    },
    swiperLoop () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        let next = this.swiperCurrent + 1
        if (next === this.swiperList.length) {
          next = 0
        }
        this.swiperCurrent = next
        this.swiperLoop()
      }, 8000)
    },
    to (type) {
      if (type === 'weChat') {
        this.isWxQrCode = true
        return
      }
      this.comp = type
    },
    // 旧逻辑
    async beforeRoute (obj) {
      console.log('routeToMode:obj', obj)
      const { lastSystemCode, serviceId, path, redirectUrl } = obj
      // type_url标识跳转官网的path
      let { redirect, source, serviceCode, unClose, redirectPath, type_url: typeURL } = this.$route.query
      const localToken = this.$ls.get(ACCESS_TOKEN)
      const subTab = await this.noteWebsite(localToken)
      // const userInfo = await getUserInfoByHideCode()

      if (serviceCode) {
        redirect = redirect + (~redirect.indexOf('?') ? `&` : '?') + `serviceCode=${serviceCode}`
      }

      let openUrl = ''

      if (typeURL && !unClose) {
        let _referrer = window.document.referrer
        if (_referrer === '') {
          _referrer = process.env.NODE_ENV === 'production' ? '//eccang.com' : '//ec.ecgtool.com'
        }
        const isDomain = /\.com([/]{0,1})$/.test(_referrer) // 判断是否顶级域名 （兼容谷歌 document.referrer ）
        openUrl = `${ isDomain ? `${ _referrer }${typeURL}` : _referrer }?token=${localToken}&subTab=${subTab}`
      } else if (!serviceId) {
        // 注册后还没部署系统时, TODO
      } else if (['entry', 'eccang'].includes(source) && !unClose) {
        // 登录成功后跳转回业务系统 （ERP | LISTING | 亚马逊 ...）
        openUrl = `/#${redirect}`
      } else if (lastSystemCode) {
        if (redirectPath) {
          openUrl = `/entry/${serviceId}/${lastSystemCode}${redirectPath}`
        } else {
          openUrl = `/entry/${serviceId}/${lastSystemCode}?token=${localToken}`
        }
      } else if (serviceId) {
        openUrl = `/entry/${serviceId}/ERP`
      } else {
        openUrl = /^http/.test(redirectUrl || '') ? redirectUrl : `/#${redirect || redirectUrl || path || '/user/home'}`
      }

      setTimeout(() => {
        window.open(openUrl, '_self')
      }, 100)
    },
    // 登录成功回调跳转处理
    // 判断是否完成引导
    async routeToMode (obj) {
      // 前置获取getGuideProgressSellerwell需要的参数
      // 1. token(已获取)
      // const { serviceId } = obj

      // 2. company
      await this.$store.dispatch('GetUserInfo', { reset: true })

      // 3. apiPath
      // const { data } = await getServiceCurrentDomainDetail({ serviceId })
      // const { domain } = (data?.serviceCurrentDomainDTOList || []).find(({ systemCode }) => systemCode === 'WMS_MANAGER')
      // console.log('baseURL', data)
      // // console.log(' window.location.href', window.location.href.includes('http://') && !domain.includes('http://'))
      // const baseURL = window.location.href.includes('https://') ? domain.replace('http://', 'https://') : domain
      // // 登录之后获取引导进度
      // await axios.post('/openapi/system/guide-page/process', { gp_code: 'light_weight_sail' }, { baseURL })
      //   .then(({ data }) => {
      //     console.log('data', data)

      //     if (data.gp_present_complete === '0') {
      //       // 是 - 跳转到引导页
      //       window.open(`/entry/${serviceId}/ERP/scm_new#/guide`, '_self')
      //     } else {
      //       // 否 - 跳转到业务系统
      //       this.beforeRoute(obj)
      //     }
      //   })
      //   .catch((err) => {
      //     console.log('err', err)
      //     this.beforeRoute(obj)
      //   })
      this.beforeRoute(obj)
    },
    // 通知官网已经登录成功
    noteWebsite (localToken) {
      return new Promise(async (resolve) => {
        let subTab
        if (!window.opener) return resolve(0)
        if (this.comp !== 'register') {
          const response = await querySystemServicePackageInfo({ systemCode: 'ERP' })
          subTab = response?.data?.subTab || 0 // 为0时跳全部视频
        }
        window.opener.postMessage({
          method: 'getWindowToken',
          data: {
            token: localToken,
            demo: this.$route.query?.demo,
            subTab // 为0时跳全部视频
          }
        }, '*')
        setTimeout(() => {
          this.$route.query?.demo && !this.$route.query.unClose && window.close()
        })
        resolve(subTab)
      })
    }
  },
  mounted () {
    // 根据url参数配置语言
    const { lang } = this.$route.query
    this.$store.dispatch('SetLang', lang || 'zh_CN')

    if (this.$ls.get(ACCESS_TOKEN)) {
      this.$router.push('/')
    }
    // bannerList({ platformCode: 'SSO_SYS_USER', paging: false, bannerStatus: 1 }).then(({ dataList }) => {
    //   this.swiperList = dataList
    //   if (dataList.length > 1) {
    //     this.swiperLoop()
    //   }
    // })
    const listener = event => {
      const { data } = event
      if (!data) return
      if (data.type === 'dingTalk' && data.path) {
        window.location.href = data.path
      }
    }
    window.addEventListener('message', listener, false)
    this.$once(`hook:beforeDestroy`, function () {
      window.removeEventListener('message', listener, false)
    })
    // console.log('LANGUAGE', this.$ls.get(LANGUAGE))
    document.title = this.$ls.get(LANGUAGE) === 'zh_CN' ? '易仓科技用户中心' : 'ECCANG'
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="less">
@color: #077BFC;
.@{ant-prefix}-btn-link {
  color: @color
}
input  {
  box-shadow: inset 0 0 0 1000px #fff!important;
}
.link {
  cursor: pointer;
  &:hover {
    color: @color;
  }
}
.language-box {
  position: fixed;
  top: 60px;
  right: 70px;
  z-index: 100;
  color: #1C2D42;
}
.login {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    /*滑道*/
    box-shadow: inset 0 0 6px rgba(102, 102, 102, 0);
    -webkit-box-shadow: inset 0 0 6px rgba(102, 102, 102, 0);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 8px;
    border-radius: 8px;

    background: rgba(102, 102, 102, 0.2);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 102, 102, 0.3);
  }
}
.switch-form {
  /* chrome */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    font-family: @fontFamily;
    -webkit-box-shadow: 0 0 0px 100px white inset;
    box-shadow: 0 0 0px 100px white inset;
    content: 'autofill';
  }
  /* firefox */
  input {
    filter: none !important;
  }
  .@{ant-prefix}-select-dropdown {
    margin-top: 50+4px;
  }
  .@{ant-prefix}-form-item {
    margin-bottom: 20px;
    .@{ant-prefix}-form-explain {
      position: absolute;
      z-index: -1;
      opacity: 0;
      font-size: 0;
    }
    .@{ant-prefix}-input-group-wrapper {
      vertical-align: top;
      top: 0;
    }
    .@{ant-prefix}-form-item-label {
      position: absolute;
      left: 0;
      right: 80px;
      top: 15px;
      height: 20px;
      line-height: 20px;
      transition: all 0.2s;
      z-index: 5;
      overflow: visible;
      label {
        color: #7F93A8;
        font-size: unset;
        cursor: auto;
        width: 100%;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        transition:all 0ms;
      }
    }
    .@{ant-prefix}-form-item-children {
      display: block;
      border-bottom: 1px #d9dfe7 solid;
    }
    .@{ant-prefix}-input-group-addon {
      border: none;
      background: transparent;
      border-radius: 0 !important;
      height: 50px;
      line-height: 50px;
      .@{ant-prefix}-select-selection {
        height: 40px;
        .@{ant-prefix}-select-selection__rendered {
          margin: 0 30px 0 0;
          width: 40px;
        }
        .@{ant-prefix}-select-arrow {
          margin-top: -10px;
        }
      }
    }
    .@{ant-prefix}-input {
      background-color: #fff !important;
      border: none;
      padding: 4px 0;
      height: 50px;
      line-height: 20px;
      border-radius: 0;
      color: #415168;
      &:focus {
        box-shadow: none;
      }
    }
    &:last-child {
      margin-bottom: 20px;
    }
  }
  .input-addon-before-form-item {
    .@{ant-prefix}-form-item-label {
      left: 70px;
    }
  }
  .@{ant-prefix}-input-affix-wrapper .@{ant-prefix}-input-suffix {
    right: 0;
    .@{ant-prefix}-btn-link {
      padding: 0;
    }
  }
}
</style>

<style lang="less" scoped>
@color: #077BFC;
.weChat-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 700px;
  background: #EBEFF4;
  z-index: 500;
  top: 0%;
  transition: all 0.5s;
  transform: translate(0, -100%);
  box-shadow: 0px 0px 100px 10px RGBA(96, 171, 255, 0.2) inset;
  overflow: hidden;
  &.show {
    top: 50%;
    transform: translate(0, -50%);
  }
  .ball1 {
    position: absolute;
    left: -150px;
    bottom: -100px;
    width: 400px;
    height: 400px;
    background: rgb(179,220,237);
    border-radius: 50%;
    box-shadow: 0 0 100px 30px RGBA(96, 171, 255, 0.2);
    background: linear-gradient(45deg,rgb(255,225,255) 0%, rgb(255,225,255) 40%, rgb(178,225,255) 100%);
  }
  .ball2 {
    position: absolute;
    right: -20vw;
    top: -68vw;
    width: 80vw;
    height: 80vw;
    background: rgb(179,220,237);
    border-radius: 50%;
    background: -webkit-linear-gradient(-45deg, #B7D4FE 10%, #ffffff 35%);
    background: linear-gradient(-45deg, #B7D4FE 10%, #ffffff 35%)
  }
}
.login {
  display: flex;
  justify-content: flex-start;
  height: 100vh;
  min-height: 700px;
  min-width: 300px;
  color: #5D6C82;
  overflow: hidden;
  & > div {
    transition: all 0.3s;
    height: 100%;
  }
  &-swiper {
    position: relative;
    overflow: hidden;
    background: #eee;
    width: 57vh;
    &-item {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: all 1s;
      &.cur {
        opacity: 1;
        z-index: 5;
      }
      &.cursor {
        cursor: pointer;
      }
    }
    &-pagination {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 50px;
      z-index: 10;
      display: flex;
      justify-content: center;
      &__bool {
        width: 20px;
        height: 7px;
        background: #C3E0FF;
        border-radius: 4px;
        opacity: 0.48;
        transition: all 0.3s;
        margin: 3px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &.cur {
          background: #DDEEFF;
          opacity: 0.75;
          width: 40px;
          &::before {
            display: inline-block;
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            border-radius: 0 4px 4px 0;
            background: #fff;
            animation: fastspin 8s linear 1;
          }
        }
      }
    }
  }
  &-main {
    flex: auto;
    padding: 0 20px;
    display: flex;
    min-width: 400px;
    align-items: center;
    justify-content: center;
    line-height: 1.43;
    section {
      width: 100%;
      max-width: 500px;
    }
    &-logo {
      color: @color;
      line-height: 0;
    }
    &-title {
      font-size: 24px;
      font-weight: bold;
      color: #1C2D42;
      margin-bottom: 30px;
      .@{ant-prefix}-btn-link {
        padding: 0;
        font-size: 24px;
        font-weight: bold;
        margin: 0 27px 0 0;
      }
    }
  }
}

@keyframes fastspin {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .login-swiper {
    width: 0;
  }
}

@media screen and (max-width: 1200px) {
  .language-box {
    right: 20px;
  }
}

</style>
